import { Component, OnInit } from '@angular/core';
import { SearchInformation } from '../../classes/search-information';

@Component({
  selector: 'app-claim-information',
  standalone: true,
  imports: [],
  templateUrl: './claim-information.component.html',
  styleUrl: './claim-information.component.css'
})
export class ClaimInformationComponent implements OnInit {
  dropDownValue: boolean;
  info: object;
  method: string;
  constructor (private searchInfo: SearchInformation) {}
  ngOnInit(): void {
    this.method = this.searchInfo.getDropDownValue() ? 'Claim' : 'Policy'
    this.info = this.searchInfo.getDropDownValue() ? this.searchInfo.getClaim() : this.searchInfo.getPolicy();
  }

}
